import apiClient from "../api";

export const getPhonesData = async (storeId, page, limit, modelId) => {
    try {
        const response = await apiClient.get(`gestock/phones/${storeId}?page=${page}&limit=${limit}&modelId=${modelId}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const getAllPhonesData = async (storeId, status, page, limit) => {
    try {
        // ?status=SOLD&page=1&limit=25
        const response = await apiClient.get(`gestock/phones/all/${storeId}?status=${status}&page=${page}&limit=${limit}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const getAllClientsData = async (storeId, page, limit, onlyDebtors) => {
    try {
        console.log({ onlyDebtors })
        const response = await apiClient.get(`gestock/stores/${storeId}/clients?onlyDebtors=${onlyDebtors}&page=${page}&limit=${limit}&onlyDebtors=${onlyDebtors}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const getClientDetailsData = async (storeId, clientPhone) => {
    try {
        const response = await apiClient.get(`gestock/stores/${storeId}/clients/${clientPhone}`);
        return response.data;
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
};

export const getExpenses = async (storeId, page = 1, limit = 20) => {
    try {
        const res = await apiClient.get(
            `/gestock/stores/${storeId}/expenses?page=${page}&limit=${limit}`
        )
        return res.data
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
}


export const getReports = async (
    storeId,
    params
) => {
    try {
        const res = await apiClient.get(
            `/gestock/stores/${storeId}/reports`,
            { params }
        )
        console.log({ res })
        return res.data
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
}

export const getStaffUsers = async (storeId, page, limit) => {
    try {
        const res = await apiClient.get(`/gestock/stores/${storeId}/users?page=${page}&limit=${limit}`)
        return res.data
    } catch (error) {
        console.log({ error });
        throw error.response?.data || error;
    }
}

export const getStores = async () => {
    try {
        const token = await localStorage.getItem('token');

        const res = await apiClient.get("/gestock/stores", {
            headers: { Authorization: `Bearer ${token}` },
        })
        return res.data
    } catch (error) {
        console.error("❌ getStores error:", error)
        throw error.response?.data || {
            message: "Erreur lors de la récupération des boutiques",
        }
    }
}

export const getActivities = async (storeId, page = 1, limit = 20) => {
    try {
        const res = await apiClient.get(`/gestock/stores/${storeId}/activities?page=${page}&limit=${limit}`)
        return res.data
    } catch (error) {
        console.error("❌ getStores error:", error)
        throw error.response?.data || {
            message: "Erreur lors de la récupération des boutiques",
        }
    }
}

export const getDashboardStat = async (storeId) => {
    try {
        const res = await apiClient.get(`/gestock/dashboard/${storeId}`)
        return res.data
    } catch (error) {
        console.error("❌ getStores error:", error)
        throw error.response?.data || {
            message: "Erreur lors de la récupération des boutiques",
        }
    }
}

export const getGeneralDashboardStat = async (storeId, threshold = 2) => {
    try {
        const token = localStorage.getItem("token")

        const res = await apiClient.get(
            `/gestock/dashboard/${storeId}/general?threshold=${threshold}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        )

        return res.data
    } catch (error) {
        console.error("❌ getGeneralDashboardStats error:", error)
        throw error.response?.data || error
    }
}


export const searchGeneralProducts = async (storeId, q) => {
    try {
        const token = localStorage.getItem("token")
        const res = await apiClient.get(
            `/gestock/stores/${storeId}/products/search?q=${encodeURIComponent(q)}`,
            { headers: { Authorization: `Bearer ${token}` } }
        )
        return res.data
    } catch (error) {
        console.error("❌ searchGeneralProducts error:", error)
        throw error.response?.data || error
    }
}

export const getGeneralProductsCatalog = async (storeId, q = "") => {
    try {
        const token = localStorage.getItem("token")
        const res = await apiClient.get(
            `/gestock/stores/${storeId}/products/catalog?q=${encodeURIComponent(q)}`,
            { headers: { Authorization: `Bearer ${token}` } }
        )
        return res.data
    } catch (error) {
        console.error("❌ getGeneralProductsCatalog error:", error)
        throw error.response?.data || error
    }
}

export const searchPhones = async (storeId, q) => {
    try {
        const token = localStorage.getItem("token")
        const res = await apiClient.get(
            `/gestock/stores/${storeId}/phones/search?q=${encodeURIComponent(q)}`,
            { headers: { Authorization: `Bearer ${token}` } }
        )
        return res.data
    } catch (error) {
        console.error("❌ searchPhones error:", error)
        throw error.response?.data || error
    }
}


export const searchGeneralDebtors = async (storeId, q) => {
  try {
    const token = localStorage.getItem("token")

    const res = await apiClient.get(
      `/gestock/stores/${storeId}/general/debtors/search?q=${encodeURIComponent(q)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )

    return res.data
  } catch (error) {
    console.error("❌ searchGeneralDebtors error:", error)
    throw error.response?.data || error
  }
}

export const searchDebtors = async (storeId, q) => {
  try {
    const token = localStorage.getItem("token")

    const res = await apiClient.get(
      `/gestock/stores/${storeId}/debtors/search?q=${encodeURIComponent(q)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    )

    return res.data
  } catch (error) {
    console.error("❌ searchDebtors error:", error)
    throw error.response?.data || error
  }
}


export const allGeneralSalesData = async (storeId, page = 1, limit = 20, params = {}) => {
  try {
    const token = localStorage.getItem("token")

    const status = params.status ?? "SOLD"
    const hasDebt = params.hasDebt ? "true" : "false"
    const q = params.q ?? ""

    const res = await apiClient.get(
      `/gestock/stores/${storeId}/general/sales?status=${encodeURIComponent(status)}&page=${page}&limit=${limit}&hasDebt=${hasDebt}&q=${encodeURIComponent(q)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )

    return res.data
  } catch (error) {
    console.log({ error })
    throw error.response?.data || error
  }
}

export const getGeneralClientsSummary = async (storeId, page = 1, limit = 20, onlyDebtors = false) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.get(
      `/gestock/stores/${storeId}/general/clients?onlyDebtors=${onlyDebtors ? "true" : "false"}&page=${page}&limit=${limit}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.log({ error })
    throw error.response?.data || error
  }
}

export const getGeneralClientDetails = async (storeId, clientPhone) => {
  try {
    const token = localStorage.getItem("token")
    const res = await apiClient.get(
      `/gestock/stores/${storeId}/general/clients/${encodeURIComponent(clientPhone)}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.log({ error })
    throw error.response?.data || error
  }
}

export const getGeneralReports = async (storeId, params) => {
  try {
    const token = localStorage.getItem("token")
    const q = new URLSearchParams(params).toString()

    const res = await apiClient.get(
      `/gestock/stores/${storeId}/general/reports?${q}`,
      { headers: { Authorization: `Bearer ${token}` } }
    )
    return res.data
  } catch (error) {
    console.log({ error })
    throw error.response?.data || error
  }
}
